<template>
  <div class="extra-user-overview">
       <div class="row head">
            <div class="col col-100">Extra gebruiker</div>
        </div>

        <div class="row">
          <div v-if="$root.app.platform == 'android'" class="col col-100" >
            <span class="row__title">E-mailadres</span><br/>
            <span class="row__subtitle">{{ email }}</span>
          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50">
            <span class="row__title">E-mailadres</span>
          </div>
          <div v-if="$root.app.platform == 'ios'" class="col col-50">
            <span class="row__subtitle">{{ email }}</span>
          </div>
        </div>

    <div class="info col">
      <p>
        <strong>LET OP!</strong><br>
        De kosten van een bundel lopen per maand, dus of je op de eerste
        of de laatste dag van de maand een bundel aanzet maakt niet
        uit je betaalt altijd hetzelfde bedrag.
      </p>
    </div>

      <div class="row row-button row-button--bottom">
        <div class="col col-100">
          <button @click="cancelUser()" class="button">Opzeggen</button>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'extraUser',
  data () {

    return {
      email: null,
      bundleSubuserId: null
    }
  },
  created(){

    this.getExtraNumber();
  },
  methods:{
    getExtraNumber(){
      this.bundleSubuserId = this.$route.params.bundleSubuserId;

      this.$api.post('/users/get-extra', {
        bundleSubuserId: this.bundleSubuserId
      })
        .then(response => {
          this.email = response.data.email;
        })
        .catch(e => {

        });
    },
    cancelUser()
    {
      var _this = this;

      this.$root.ui.showDialog(
      'Extra gebruiker verwijderen',
      'Weet u zeker dat u deze extra gebruiker wilt verwijderen?',
        false,
        {
          0:{
            name: 'Ik ga akkoord',
            execute: function(){
              _this.$api.post('/users/remove-extra', {
                bundleSubUserId: _this.bundleSubuserId
              })
                .then(response => {
                  _this.$root.loading = false;

                  _this.$root.ui.showDialog(
                    'Voltooid',
                    'De extra gebruiker is verwijderd!',
                    true
                  );
                  _this.$router.go(-1); //Back to bundels
                })
                .catch(e => {
                  _this.$root.loading = false;
                  _this.$root.ui.showDialog(
                    'Fout',
                    e.response.data.message,
                    true
                  )
                });
            }
          },
          1:{
            name: 'Annuleren',
            execute: function(){}
          }
        }
    );
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/bundles/ExtraUserOverview.vue